import React, { useState, useEffect } from "react";
import RequestHandler from "util/RequestHandler";
import moment from "moment";
import EInvoiceTableFilter from "../Filters/EInvoiceTableFilter";
import { ColumnHelper } from "util/TableHelper";
import Replace2x from "../../util/Extensions/ReplaceExtension";
import FirmAddForm from "../Forms/FirmAddForm";
import { Table, Empty, Button, Col, Row, Drawer, notification, Tooltip, Modal, Tabs, message, Form, Input } from "antd";
import { BarsOutlined, WarningOutlined, FilePdfOutlined, ExclamationCircleOutlined, SendOutlined } from "@ant-design/icons";
import { defaultValidateMessages } from "../Forms/Helper";

import config from "../../util/ApiforContext";
const formItemLayout = {
  labelCol: {
    xs: {
      span: 24,
    },
    sm: {
      span: 6,
    },
  },
  wrapperCol: {
    xs: {
      span: 24,
    },
    sm: {
      span: 24,
    },
  },
};
const { TabPane } = Tabs;
const EinvoiceList = (props) => {
  const [tableData, setTableData] = useState({
    data: [],
    total: 0,
    loading: true,
  });
  const [tableDataQueryOptions, setTableDataQueryOptions] = useState({
    skip: 0,
    take: 15,
    current: 1,
    filter: "",
    activeTab: "true",
  });
  const [addVisible, setAddVisible] = useState(true);
  const [addAccRejectVisible, setAddAccRejectVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loadingPlan, setLoadingPlan] = useState(false);
  const [totalAmount, setTotalAmount] = useState();
  const [firmName, setFirmName] = useState();
  const [vkn, setVkn] = useState();
  const [tckn, setTckn] = useState();
  const [tab, setTab] = useState(true);
  const [defaultMail, setDefaultMail] = useState("");
  const [selectedRows, setSelectedRows] = useState({
    keys: [],
    data: [],
  });
  const [addFirmDrawerVisible, setAddFirmDrawerVisible] = useState(false);
  const [form] = Form.useForm();
  const [sendMailModal, setSendMailModal] = useState({
    visible: false,
    data: null
  });
  const [mailLoading, setMailLoading] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState(null);

  const renderActionButtons = () => {
    if (selectedStatus === 69) {
      return (
        <div>
          <Button type="primary" onClick={handleAccept}>
            Kabul
          </Button>
          <Button type="danger" onClick={handleReject}>
            Ret
          </Button>
        </div>
      );
    }
    return null;
  };

  const handleAccept = () => {
    if (selectedRows.data.length > 0) {
      const updatedRows = selectedRows.data.map((row) => ({
        id: row.id,
        eInvoiceStatusId: 12,
      }));

      RequestHandler.put(`/Einvoice/UpdateInvoiceStatus`, updatedRows)
        .then((response) => {
          if (response.success) {
            message.success("Seçilen kayıtlar Kabul Edildi.");

            setTimeout(() => {
              getTableData();
            }, 2000);
          } else {
            message.error("İşlem sırasında hata oluştu.");
          }
        })
        .catch((error) => {
          message.error("İstek sırasında bir hata oluştu.");
        });
    } else {
      message.warning("Lütfen en az bir kayıt seçiniz.");
    }
  };
  const handleReject = () => {
    if (selectedRows.data.length > 0) {
      const updatedRows = selectedRows.data.map((row) => ({
        id: row.id,
        eInvoiceStatusId: 31,
      }));

      RequestHandler.put(`/Einvoice/UpdateInvoiceStatus`, updatedRows)
        .then((response) => {
          if (response.success) {
            message.success("Seçilen kayıtlar Reddedildi.");

            setTimeout(() => {
              getTableData();
            }, 2000);
          } else {
            message.error("İşlem sırasında bir hata oluştu.");
          }
        })
        .catch((error) => {
          message.error("İstek sırasında bir hata oluştu.");
        });
    } else {
      message.warning("Lütfen en az bir kayıt seçiniz.");
    }
  };

  useEffect(() => getTableData(), [tableDataQueryOptions]);

  const getFilterQuery = () => {
    const { filter, activeTab } = tableDataQueryOptions;

    const conditions = [];
    let query = "";

    switch (activeTab) {
      case "true":
        conditions.push(`isOut eq true`);
        break;

      case "false":
        conditions.push(`isOut eq false`);
        break;
    }

    if (filter) {
      conditions.push(filter);
    }

    if (conditions.length !== 0) {
      query = "$filter=" + conditions.join(" and ");
    }
    return query;
  };
  const showDrawer = (firmName, vkn, tckn) => {
    setFirmName(firmName)
    setVkn(vkn)
    setTckn(tckn)
    setAddFirmDrawerVisible(true);
  };

  const onClickSendMail = (pdfId) => {
    setSendMailModal({ visible: true, data: { id: pdfId } })
  };

  const onClose = () => {
    setAddFirmDrawerVisible(false);
  };
  const getTableData = () => {
    setTableData({
      ...tableData,
      loading: true,
    });

    const { skip, take } = tableDataQueryOptions;
    RequestHandler.get(
      `/Einvoice?$count=true&${getFilterQuery()}&$skip=${skip}&$top=${take}`
    ).then((response) => {
      setTableData({
        data: response.value,
        total: response["@odata.count"],
        loading: false,
      });
    });
    RequestHandler.get(
      `/Einvoice/GetTotal?$count=true&${getFilterQuery()}&$select=totalAmount`
    ).then((response) => {
      const total = response.reduce((accumulator, item) => accumulator + item.totalAmount, 0);
      setTotalAmount(ColumnHelper.renderDecimal(total))
    });
  };

  const paging = (p) => {
    setTableDataQueryOptions((prevState) => {
      return {
        ...prevState,
        skip: (p.current - 1) * prevState.take,
        take: p.pageSize,
        current: p.current,
      };
    });
  };
  const onChangeTab = (actKey) => {
    let actKeyVal = actKey === "true" ? true : false;
    setTab(actKeyVal)
    setAddVisible(actKeyVal)
    setTableData({
      loading: true
    })
    RequestHandler.get(
      `/Einvoice/GetTotalAmount?isSend=${actKeyVal}`
    ).then((response) => {
      setTotalAmount(response)
    });
    const { skip, take } = tableDataQueryOptions;
    setTableDataQueryOptions({
      skip: 0,
      current: 1,
      take: tableDataQueryOptions.take,
      activeTab: actKey,
    });

    if (!actKeyVal) {
      setAddAccRejectVisible(true)
    } else {
      setAddAccRejectVisible(false)
    }
  }

  const onClearTableFilter = () => {
    setTableDataQueryOptions({
      skip: 0,
      current: 1,
      take: tableDataQueryOptions.take,
      filter: "",
      activeTab: tab === true ? "true" : "false"
    });
  };

  const onFinishTableFilter = (query) => {
    var isOut = tab === undefined ? true : tab;
    if (!query) {
      query = "isOut eq " + isOut;
    } else {
      query = query + " and isOut eq " + isOut;
    }
    setTableDataQueryOptions((prevState) => {
      return { skip: 0, current: 1, take: prevState.take, filter: query };
    });
  };
  const pdfError = (type) => {
    notification[type]({
      message: "HATA",
      description: "Pdf oluşturulamadı.",
      duration: 2,
    });
  };
  const downloadPdf = (id) => {
    const hide = message.loading('Pdf Açılıyor...', 0);
    setTimeout(hide, 2000);
    RequestHandler.get(
      `/Einvoice/GetInvoicePdf/${id}`
    ).then((response) => {
      if (response === "") {
        pdfError("error")
      }
      else {
        RequestHandler.get(
          `/EInvoice/DownloadEInvoice?fileName=${response}`,
          undefined,
          { rawResponse: true, responseType: "blob" }
        ).then((response) => {
          if (response.status == 200) {
            const url = URL.createObjectURL(response.data);
            window.open(url);
          }
        });
      }

    });
  };
  const downloadComingPdf = (id) => {
    const hide = message.loading('Pdf Açılıyor...', 0);
    setTimeout(hide, 2000);
    RequestHandler.get(
      `/EInvoice/DownloadEInvoice?fileName=${id}`,
      undefined,
      { rawResponse: true, responseType: "blob" }
    ).then((response) => {
      if (response.status == 200) {
        const url = URL.createObjectURL(response.data);
        window.open(url);
      }
    });
  };
  const sendPdfMail = () => {
    const hide = message.loading('Mail gönderiliyor...', 0);
    setTimeout(hide, 2000);
    RequestHandler.get(
      `/Einvoice/GetInvoicePdf/${sendMailModal.data.id}`
    ).then((response) => {
      if (response === "") {
        pdfError("error")
      }
      else {
        RequestHandler.post(
          `/Einvoice/SendMail`,
          {
            Filename: response,
            Email: defaultMail,
            Token: Replace2x(
              localStorage.getItem("token")
            )
          },
          true
        ).then((response) => {
          if (!response.success) {
            pdfError("error");
          }
          else {
            setSendMailModal({ visible: false, data: null });
          }
          setLoading(false);
        });
      }

    });
  };

  const onTableSelectChange = (selectedKeys, selectedRecords) => {
    setSelectedRows({
      keys: selectedKeys,
      data: selectedRecords,
    });

    if (selectedRecords.length > 0) {
      setSelectedStatus(selectedRecords[0].eInvoiceStatusId);
    } else {
      setSelectedStatus(null);
    }
  };


  const onClickAddPlan = () => {
    const filteredRows = selectedRows.data.filter(row => row.firmId === null);
    if (filteredRows.length > 0) {
      Modal.confirm({
        title: "Uyarı!",
        icon: <ExclamationCircleOutlined />,
        content:
          "Cari eşleştirmesi olmayan kayıtlar var. Bu kayıtlar için Cari ‘Diğer’ olarak atanır. Devam etmek istiyor musunuz ?",
        okText: "Tamam",
        cancelText: "Vazgeç",
        onOk() {
          RequestHandler.post(`/MonthlyPlan/EInvoiceAddPlan`, {
            eInvoiceIds: selectedRows.keys
          }).then((response) => {
            if (response.success) {
              setTimeout(() => {
                window.location.reload();
              }, 1500);
            }
          });
        },
      });
    } else {
      RequestHandler.post(`/MonthlyPlan/EInvoiceAddPlan`, {
        eInvoiceIds: selectedRows.keys
      }).then((response) => {
        if (response.success) {
          setTimeout(() => {
            window.location.reload();
          }, 1500);
        }
      });
    }
  }




  const firmNameText = "Firma tanımlı değil. Eklemek için tıklayın."
  const tableColumns = [
    {
      title: "Fatura Numarası",
      align: "center",
      dataIndex: "eInvoiceNumber",
    },
    {
      title: "Cari",
      dataIndex: "firmName",
      render: (text, row, index) => {
        return (
          <> {row.isExistFirm != true ?
            <> <Tooltip placement="rightBottom" title={firmNameText}>{row.firmName} <a onClick={() => { showDrawer(row.firmName, row.vkn, row.tckn) }} style={{ color: "red", fontSize: "130%" }}><WarningOutlined /></a></Tooltip> </>
            : row.firmName}
          </>
        );
      },
    },
    {
      title: "Senaryo",
      align: "center",
      dataIndex: "senario",
    },
    {
      title: "Vkn/Tckn",
      dataIndex: "vkn",
      align: "center",
      key: "vkn",
      render: (text, row, index) => {
        return (
          row.vkn == null ? row.tckn : row.vkn
        );
      },
    },
    {
      title: "Fatura Tipi",
      align: "center",
      dataIndex: "type",
    },
    // {
    //     title: "Para Birimi",
    //     align:"center",
    //     dataIndex: "currencyCode",
    //   },
    {
      title: "Toplam Tutar",
      dataIndex: "totalAmount",
      align: "center",
      render: ColumnHelper.renderDecimal,
    },
    // {
    //   title: "Kdv'siz Tutar",
    //   dataIndex: "totalAmountWithoutTax",
    //   align:"center",
    //   render: ColumnHelper.renderDecimal,
    // },
    // {
    //   title: "Toplam Kdv",
    //   dataIndex: "totalTaxAmount",
    //   align:"center",
    //   render: ColumnHelper.renderDecimal,
    // },
    {
      title: "Tarih",
      dataIndex: "date",
      align: "center",
      render: (data, row, index) => moment(data).format("DD.MM.YYYY"),
    },
    {
      title: "Durum",
      align: "center",
      dataIndex: "status",
      render: (data, row, index) => {
        return <><Tooltip placement="rightBottom" title={row.statusDetail}>{row.status} </Tooltip></>
      }
    },
    {
      title: "Pdf",
      align: "center",
      dataIndex: "invoiceData",
      render: (data, row, index) => {
        if (row.isOut) {
          if ((row.invoiceData != null && row.eInvoiceProgramId == 2) || row.invoiceNoId != "00000000-0000-0000-0000-000000000000" && row.eInvoiceProgramId == 1) {
            return <a onClick={() => { downloadPdf(row.id) }}><FilePdfOutlined style={{ fontSize: '140%', color: 'darkRed' }} /></a>;
          } else if (row.invoiceNoId != "00000000-0000-0000-0000-000000000000" && row.eInvoiceProgramId == 3) {
            return <a onClick={() => { downloadComingPdf(row.invoiceNoId) }}><FilePdfOutlined style={{ fontSize: '140%', color: 'darkRed' }} /></a>;
          }
        } else {
          if ((row.invoiceData != null && row.eInvoiceProgramId == 2 || (row.invoiceNoId != "00000000-0000-0000-0000-000000000000" && row.eInvoiceProgramId == 3))) {
            return <a onClick={() => { downloadComingPdf(row.invoiceNoId) }}><FilePdfOutlined style={{ fontSize: '140%', color: 'darkRed' }} /></a>;
          }
          else if (row.invoiceNoId != "00000000-0000-0000-0000-000000000000" && row.eInvoiceProgramId == 1) {
            return <a onClick={() => { downloadPdf(row.id) }}><FilePdfOutlined style={{ fontSize: '140%', color: 'darkRed' }} /></a>;
          }
        }

      }
    },
    {
      title: "Mail",
      align: "center",
      dataIndex: "invoiceMail",
      render: (data, row, index) => {
        return <a onClick={() => { onClickSendMail(row.invoiceNoId) }}><SendOutlined /></a>;
      }
    }
  ];

  return (
    <>
      <Row>
        <Col xs={24} md={12} lg={16}>
          <p style={{ fontSize: "120%", marginTop: -5 }}>
            <BarsOutlined /> E-FATURA LİSTESİ
          </p>
        </Col>
        <Col xs={24} md={12} lg={8} style={{ textAlign: "right" }}>
          {
            addVisible ?
              <>
                <a onClick={() => { onClickAddPlan() }}>
                  <Button
                    style={{ marginRight: 15 }}
                    loading={loadingPlan}
                    disabled={selectedRows.keys.length > 0 ? false : true}
                    type='primary'
                  >
                    Plana Ekle
                  </Button>
                </a>
                <a href="/create-invoice" onClick={() => { setLoading(true) }}>
                  <Button
                    style={{ marginRight: 15 }}
                    loading={loading}
                    type='primary'
                  >
                    E-Fatura Ekle
                  </Button>
                </a>
              </>
              :
              <a onClick={() => { onClickAddPlan() }}>
                <Button
                  style={{ marginRight: 15 }}
                  loading={loadingPlan}
                  type='primary'
                  disabled={selectedRows.keys.length > 0 ? false : true}
                >
                  Plana Ekle
                </Button>
              </a>
          }
          {addAccRejectVisible && renderActionButtons()}
        </Col>
      </Row>

      <EInvoiceTableFilter
        onClearFilter={onClearTableFilter}
        onFinishFilter={onFinishTableFilter}
        style={{ marginTop: 12, marginBottom: 12 }}
      />

      <Tabs defaultActiveKey="true" onChange={onChangeTab} tabBarExtraContent={<strong>Toplam Tutar : {totalAmount}</strong>}>
        <TabPane tab="GİDEN" key="true" />

        <TabPane tab="GELEN" key="false" />

      </Tabs>
      <Row id="tableArea">
        <Col span={24}>
          <Table
            rowSelection={{
              selectedRowKeys: selectedRows.keys,
              onChange: onTableSelectChange,
              getCheckboxProps: (record) => ({
                disabled: record.isSendMonthlyPlan,
              }),
            }}
            columns={tableColumns.filter((column) => !column.isRowDetail)}
            // expandable={{
            //     expandedRowRender: (row) => detailEInvoiceItem(row.eInvoiceItems),
            //   }}
            locale={{
              emptyText: (
                <Empty
                  image={Empty.PRESENTED_IMAGE_SIMPLE}
                  description="Veri Yok"
                />
              ),
            }}
            style={{
              overflowX: "auto",
              maxHeight: "100%",
              width: "100%",
            }}
            rowKey="id"
            filterable={true}
            sortable={true}
            pageable={true}
            onChange={paging}
            pagination={{
              defaultPageSize: tableDataQueryOptions.take,
              pageSizeOptions: ["15", "25", "50", "100"],
              total: tableData.total,
              current: tableDataQueryOptions.current,
            }}
            dataSource={tableData.data}
            loading={tableData.loading}
            size="small"
          />
        </Col>
      </Row>
      <Drawer
        title="Cari Ekle"
        width={241}
        onClose={onClose}
        visible={addFirmDrawerVisible}
        bodyStyle={{ paddingBottom: 80 }}
        footer={
          <div
            style={{
              textAlign: "right",
            }}
          ></div>
        }
      >
        <FirmAddForm IsEinvoice={true} SenderName={firmName} Tckn={tckn} Vkn={vkn} />
      </Drawer>
      <Modal
        id="sendMail"
        centered
        visible={sendMailModal.visible}
        onCancel={() => setSendMailModal({ visible: false, data: null })}
        footer={null}
      >
        <Form
          {...formItemLayout}
          validateMessages={defaultValidateMessages}
          form={form}
          name="sendMail"
          initialValues={{
            remember: true,
          }}
          onFinish={() => sendPdfMail()}
          onFinishFailed={() => setLoading(false)}
          fields={[
            { name: "email", value: defaultMail }
          ]}
        >
          <Row>
            <Col span={24}>
              <Form.Item name="id" hidden>
                <Input />
              </Form.Item>

              <Form.Item
                label="E-Posta"
                name="email"
                rules={[{ required: true, type: "email" }]}
              >
                <Input value={defaultMail} onChange={(text) => { setDefaultMail(text.target.value) }} disabled={mailLoading} />
              </Form.Item>
            </Col>
            <Col span={24} style={{ textAlign: "right" }}>
              <Button
                type="primary"
                icon={<SendOutlined />}
                htmlType="submit"
                onClick={() => setLoading(true)}
                loading={loading}
              >
                Gönder
              </Button>
            </Col>
          </Row>
        </Form>
      </Modal>
    </>
  );
};

export default EinvoiceList;
